import React, { useEffect, useState } from 'react';
import { Select } from 'antd';

const { Option } = Select;

const SpPagination = ({ total = 0, defaultCurrent = 1, pageSize = 10, onChange }) => {
  // Validate and sanitize inputs
  const validPageSize = Math.max(1, pageSize); // Prevent division by 0
  const validTotal = Math.max(0, total); // Ensure total is non-negative
  const totalPages = Math.max(1, Math.ceil(validTotal / validPageSize)); // Ensure at least 1 page

  // Initialize state for the current page
  const [currentPage, setCurrentPage] = useState(
    Math.max(1, Math.min(defaultCurrent, totalPages))
  );

  useEffect(() => {
    setCurrentPage(Math.max(1, Math.min(defaultCurrent, totalPages)));
  }, [defaultCurrent, totalPages]);

  // Handle page selection changes
  const handleSelectChange = (value) => {
    setCurrentPage(value);
    if (typeof onChange === 'function') {
      onChange(value);
    }
  };

  // Generate options for the Select component
  const pageOptions = validTotal === 0 ? [] : Array.from({ length: totalPages }, (_, i) => i + 1);

  // Calculate the range of items displayed on the current page
  const startItem = validTotal === 0 ? 0 : (currentPage - 1) * validPageSize + 1;
  const endItem = Math.min(startItem + validPageSize - 1, validTotal);

  return (
    <div className="sp-pagination">
      {/* Page selection on the left */}
      <div className="sp-pagination__page-control">
        Page
        <Select
          aria-label="Select page"
          className="sp-pagination__select"
          value={currentPage}
          onChange={handleSelectChange}
        >
          {pageOptions.map((page) => (
            <Option key={page} value={page}>
              {page}
            </Option>
          ))}
        </Select>
        of {totalPages}
      </div>

      {/* Item range on the right */}
      <div className="sp-pagination__summary">
        {validTotal === 0
          ? 'No records to display.'
          : `Showing ${startItem} to ${endItem} of ${validTotal}`}
      </div>
    </div>
  );
};

export default SpPagination;
